async function HandlePromotion(evt, result, $el) {
  const $document = $(document);
  const $template = $document.find('script[data-id="rnk-template-promotion"]').text();
  let orderForm = result;

  const handle = () => {
    showPopUp();
    closePopUp();
    buyProductShelf();
    PopUpPdpd();
  };

  const showPopUp = async () => {
    const $product = $($el).parent().parent().closest('li');
    const qnt = $product.find('.c-quantidade').val();

    const hasFlag = true || $product.find('.flag.compre-2-e-economize-10-').length; // TODO: mudar para pegar da propria shelf e url;

    const skuId = $product.find('[data-track-shelf-sid]').attr('data-track-shelf-sid');

    const skuOnOrderForm = orderForm.items.find((s) => String(s.id) === String(skuId));

    const msg = $product.find('.flag.compre-2-e-economize-10-').text() || '10% OFF na compra da 2a unidade.';

    const lastBannerTop = $document.find('div.container.promotion-banner').last();
    const bannerHeight = 68;
    const marginBanner = 10;
    const posBannerTop = 80;

    const top = lastBannerTop.length
      ? lastBannerTop?.offset()?.top + lastBannerTop.height() + marginBanner
      : posBannerTop;
    const bottom = lastBannerTop.length ? Number(lastBannerTop.attr('data-bottom')) + posBannerTop : posBannerTop;

    const obj = { idSku: skuId, qnt: 2, msg, top: `${bottom}px`, bottom: bottom };

    if (!skuOnOrderForm && Number(qnt) % 2 !== 0) {
      renderPoup(obj);
    } else {
      const isOdd = skuOnOrderForm?.quantity == 1 || Number(skuOnOrderForm?.quantity - 1) % 2 == 0;

      if (hasFlag && isOdd) {
        renderPoup(obj);
      }
    }
  };

  const closePopUp = () => {
    const close = (banner) => {
      const $banner = banner.parent().closest('.promotion-banner');
      $banner.remove();
    };

    $document.on('click', '.close-banner', (e) => {
      const $current = $(e.currentTarget);
      close($current);
    });

    $document.on('close-banner', (_, e) => {
      console.log('testeaa', e);
      const $current = $(e.target);
      close($current);
    });
  };

  const buyProductShelf = () => {
    $document.on('click', '.bnt-action-buy', async (e) => {
      const $e = $(e.target);
      const skuId = $e.attr('sku-id');

      const index = (orderForm?.items || []).findIndex((prod) => String(prod.id) == String(skuId));
      const qnt = orderForm?.items[index].quantity + 2;
      // const updateItem = { quantity: qnt, index };

      // result = await vtexjs.checkout.updateItems([updateItem], null, false);

      await buyProduct(skuId, qnt);
      $document.trigger('close-banner', [e]);
    });
  };

  const renderPoup = (obj) => {
    const html = window.storeTheme.helpers.mustache.render($template, obj);
    $document.find('body').append(html);
  };

  async function buyProduct(skuId, quantity = 2) {
    const index = (orderForm?.items || []).findIndex((prod) => String(prod.id) == String(skuId));
    const seller = orderForm.salesChannel;

    let result;
    if (index >= 0) {
      const updateItem = {
        quantity: quantity,
        index,
      };
      result = await vtexjs.checkout.updateItems([updateItem], null, false);
    } else {
      const item = {
        id: skuId,
        quantity,
        seller,
      };

      result = await vtexjs.checkout.addToCart([item], null, seller);
    }

    // const qnt = orderForm?.items[index].quantity + 2;
    const updateItem = { quantity: quantity, index };

    result = await vtexjs.checkout.updateItems([updateItem], null, false);
  }

  function PopUpPdpd() {
    const $document = $(document);
    const sku = window.skuJson?.skus?.[0]?.sku;

    $document.on('click', '.flag.compre-2-e-economize-10-', async () => {
      orderForm = await window.vtexjs.checkout.getOrderForm().promise();
      const index = (orderForm?.items || []).findIndex((prod) => String(prod.id) == String(sku));

      const qnt = index >= 0 ? orderForm?.items[index].quantity + 2 : 2;
      if (sku) {
        await buyProduct(sku, qnt);
      }
    });
  }

  handle();
}

if ($('body').hasClass('rnk-body-produto')) {
  (async () => {
    HandlePromotion(
      null,
      window.vtexjs.checkout.orderForm || (await window.vtexjs.checkout.getOrderForm().promise()),
      null,
    );
  })();
}

// $(window).on('loadPromotion', HandlePromotion);

$(window).on('buy-qnt-add', HandlePromotion);
$(window).on('buy-qnt-update', HandlePromotion);

export {};
